export const KST = 'Asia/Seoul';

export const ABSOLUTE_DATE_TIME_FORMAT = 'yyyy. MM. dd. a hh:mm';
